import { useEffect } from 'react';
import { createFileRoute } from '@tanstack/react-router';

import { useRouter } from '../services/Navigation';
import { Routes } from '../services/Navigation/Routes';

export const Route = createFileRoute('/')({
  staticData: {
    secure: false,
  },
  component: AppSelectorRoute,
});

function AppSelectorRoute() {
  const router = useRouter();

  useEffect(() => {
    router.push(Routes.bookSetup.path);
  }, [router]);

  return null;
}
